export default {
  back: 'Tilbage til kampagner',
  title: 'Kampagne',
  sent_at: 'Sendt {{time}}',
  breakdown_title: 'Leveringsoversigt',
  pending_receipts: {
    title: 'Leveringsstatistik er på vej',
    description:
      'Denne kampagne er netop sendt. Push-udbydere bekræfter levering ca. 15 minutter efter afsendelse, så tallene nedenfor udfyldes omkring {{time}} – ingen handling er nødvendig.',
    countdown:
      'Apple og Google bekræfter modtagelse om ca. {{minutes}}m {{seconds}}s (omkring {{time}}). Statistikken opdateres automatisk.',
    ready: 'Kvitteringerne burde være modtaget. Tallene nedenfor opdateres nu.',
    soon: 'snart',
  },
  recipients: {
    title: 'Modtagere',
    subtitle: 'Hvem kampagnen blev sendt til, og om den nåede frem til deres enhed.',
    filters: {
      all: 'Alle',
      delivered: 'Leveret',
      pending: 'Afventer bekræftelse',
      failed: 'Ikke leveret',
    },
    columns: {
      recipient: 'Modtager',
      status: 'Status',
      reason: 'Årsag',
      clicked: 'Klikket',
      sent_at: 'Sendt kl.',
    },
    status: {
      delivered: 'Leveret',
      pending: 'Afventer bekræftelse',
      failed: 'Ikke leveret',
    },
    reasons: {
      DeviceNotRegistered: 'App fjernet eller notifikationer slået fra (udløbet token)',
      MessageRateExceeded: 'Midlertidigt hastighedsbegrænset af Expo',
      MessageTooBig: 'Notifikationens indhold er for stort',
      MismatchSenderId: 'Push-legitimationsoplysninger stemmer ikke overens',
      InvalidCredentials: 'Ugyldige push-legitimationsoplysninger',
      batch_failed: 'Afsendelse af batch mislykkedes',
      missing_ticket: 'Ingen bekræftelse modtaget fra Expo',
      unknown: 'Ukendt leveringsfejl',
    },
  },
};
